import { repository, baseURL } from "@/api/base"

export default {
  async applicationProgramTransfer(applicationId) {
    const { data } = await repository.get(baseURL + `/print/applicationProgramTransfer/${applicationId}`, { responseType: "arraybuffer" })
    return data
  },

  async applicationReinstate(applicationId) {
    const { data } = await repository.get(baseURL + `/print/applicationReinstate/${applicationId}`, { responseType: "arraybuffer" })
    return data
  },

  async applicationTransfer(applicationId) {
    const { data } = await repository.get(baseURL + `/print/applicationTransfer/${applicationId}`, { responseType: "arraybuffer" })
    return data
  },
}
